import { render, staticRenderFns } from "./HotpointPic.vue?vue&type=template&id=20bed38c&scoped=true"
import script from "./HotpointPic.vue?vue&type=script&lang=js"
export * from "./HotpointPic.vue?vue&type=script&lang=js"
import style0 from "./HotpointPic.vue?vue&type=style&index=0&id=20bed38c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bed38c",
  null
  
)

export default component.exports